module.exports = __webpack_public_path__ + "static/media/map.faf3a260.png";